import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole } from "@/hooks/useUserRole";
import { MAINTENANCE_MODE, MAINTENANCE_ALLOWED_PATHS } from "@/config/maintenance";
import Maintenance from "@/pages/Maintenance";

/**
 * Bloqueia o site inteiro quando MAINTENANCE_MODE está ativo.
 * - Admins autenticados sempre passam.
 * - Rotas em MAINTENANCE_ALLOWED_PATHS (ex.: /auth) ficam liberadas
 *   para permitir o login de administradores.
 */
const MaintenanceGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const { isAdmin, roleLoading } = useUserRole();

  if (!MAINTENANCE_MODE) return <>{children}</>;

  if (MAINTENANCE_ALLOWED_PATHS.some((p) => pathname.startsWith(p))) {
    return <>{children}</>;
  }

  // Enquanto resolvemos auth/role, evita "flash" da tela de manutenção
  // para um admin que está autenticado.
  if (loading || (user && roleLoading)) {
    return null;
  }

  if (isAdmin) return <>{children}</>;

  return <Maintenance />;
};

export default MaintenanceGate;
